module.exports = __webpack_public_path__ + "static/media/4_k2U_82,03_45,28.7efd9d5d.png";